import styled from "styled-components";

const Block = styled.section`
  background: #eee;
  font-family: "Alef", sans-serif;
  direction: rtl;
  margin-bottom: 0.5em;
`;

export default Block;
